module.exports = __webpack_public_path__ + "img/refund.9cac0c39.svg";